import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";
import uiReducer from "./slices/uiSlice";
import toastReducer from "./slices/toastSlice";
import authReducer from "./slices/authSlice";
import visitorsReducer from "./slices/visitorsSlice";
import callsReducer from "./slices/callsSlice";
import callRequestsReducer from "./slices/callRequestsSlice";
import analyticsReducer from "./slices/analyticsSlice";
import teamReducer from "./slices/teamSlice";
import notificationsReducer from "./slices/notificationsSlice";

// Configure store with security considerations
export const store = configureStore({
  reducer: {
    ui: uiReducer,
    toast: toastReducer,
    auth: authReducer,
    visitors: visitorsReducer,
    calls: callsReducer,
    callRequests: callRequestsReducer,
    analytics: analyticsReducer,
    team: teamReducer,
    notifications: notificationsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore certain action types for non-serializable data if needed
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
  devTools: import.meta.env.NODE_ENV !== "production",
});

// Define RootState and AppDispatch types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks for Redux
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
